import { Injectable } from '@angular/core';
import { DbService } from './db.service';
import { TranslateService } from '@ngx-translate/core';

export interface TranslateSource {
    id?: string;
    open: Boolean;
    type: string;
    seq: string;
    ko?: string;
    en?: string;
    ja?: string;
};

@Injectable({
  providedIn: 'root',
})
export class TranslateRealService {
  private allData: TranslateSource[] = [];

  constructor(
    private db: DbService,
    private translate: TranslateService,
  ) {
    this.initData();
  }

  private initData() {
    this.db.collection$(`langTranslate`).subscribe(data => {
      this.allData = data;
    });
  }

  getTranslateValue(type: string, seq: string, content:string): string {
    let translateData;
    if(type === 'text') {
      translateData = this.allData.find(item => item.type === type && item.ko === content);
    }else {
      translateData = this.allData.find(item => item.type === type && item.seq === seq);
    }
    const lang = this.translate.getCurrentLang() || this.translate.getFallbackLang();
    switch(lang) {
      case 'en':
        return translateData?.en || content;
      case 'ja':
        return translateData?.ja || content;
      default:
        return translateData?.ko || content;
    }
  }
}
